export default __webpack_public_path__ + "static/media/bs-secondary-suv.150ff283.svg";